import * as React from "react";

const CloseMenuIcon = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={16}
        height={17}
        viewBox="0 0 17 17"
        {...props}
    >
      <path d="M16.894.106a.351.351,0,0,0-.5,0L8.493,8,.6.106a.342.342,0,0,0-.5,0,.342.342,0,0,0,0,.5L8,8.5l-7.9,7.895a.35.35,0,0,0,0,.5A.356.356,0,0,0,.354,17,.344.344,0,0,0,.6,16.894L8.5,9l7.9,7.895a.356.356,0,0,0,.248.106.344.344,0,0,0,.248-.106.35.35,0,0,0,0-.5L9,8.5,16.894.6a.35.35,0,0,0,0-.5Z" />
  </svg>
  
)

export default CloseMenuIcon;
